export const returnHref = (href: string) => {
  // We do not want users to accidentally click on a button and go somewhere. When a user open a page in his website (rendered by DJango) he gets normal hrefs.
  // return href;
  return "javascript:void(0);";
};
